import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

export const GetNotifications = createAsyncThunk(
  "Home/GetNotifications",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(
          `${process.env.REACT_APP_BACKEND_API}api/dashboard/notifications`,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
export const updateNotifications = createAsyncThunk(
  "Home/updateNotifications",
  async (id, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .put(
          `${process.env.REACT_APP_BACKEND_API}api/dashboard/notifications/${id}`,
          { id: id },
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const getCompany = createAsyncThunk(
  "Home/getCompany",
  async (_, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .get(`${process.env.REACT_APP_BACKEND_API}api/company/me`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("QanonToken")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        })
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updateSetting = createAsyncThunk(
  "Home/updateSetting",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/company/me/update`,
          data,
          {
            headers: {
              Authorization: `Bearer ${Cookies.get("QanonToken")}`,
              "Content-Type": "multipart/form-data",
              Accept: "application/json",
            },
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data.errors);
    }
  }
);

const HomeSlice = createSlice({
  name: "Home",
  initialState: {
    isHomeLoading: false,
    ColorsArr: null,
    SizeArr: null,
    notificationArr: null,
    getCompanyArray: null,
  },

  extraReducers: {
    [getCompany.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [getCompany.fulfilled]: (state, action) => {
      state.isHomeLoading = false;
      state.getCompanyArray = action.payload.data;
    },
    [getCompany.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },

    [updateSetting.pending]: (state, action) => {
      state.isHomeLoading = true;
    },
    [updateSetting.fulfilled]: (state, action) => {
      state.isHomeLoading = false;
    },
    [updateSetting.rejected]: (state, action) => {
      state.isHomeLoading = false;
    },

    [GetNotifications.fulfilled]: (state, action) => {
      state.notificationArr = action.payload.data;
    },
  },
});

export default HomeSlice.reducer;
